/* WestMorning product page behaviour: tabs, bundle picker, shipping countdown, scroll-to-cart */
(() => {
  if (window.wmProductInit) return;
  window.wmProductInit = true;

  // Tabs: [data-wm-tabs] wraps buttons [data-wm-tab="id"] and panels [data-wm-panel="id"]
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-wm-tab]');
    if (!tab) return;
    const root = tab.closest('[data-wm-tabs]');
    if (!root) return;
    const id = tab.dataset.wmTab;
    root.querySelectorAll('[data-wm-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll('[data-wm-panel]').forEach((p) => (p.hidden = p.dataset.wmPanel !== id));
  });

  // Bundle picker: writes the chosen variant into the product form of the same section
  // Savings bar + free-bonus unlocks for the selected pack
  const syncExtras = (input, section) => {
    const bundle = input.closest('[data-wm-bundle]');
    const bar = bundle?.querySelector('[data-wm-saving]');
    if (bar) {
      const saving = Number(input.dataset.saving) || 0;
      bar.hidden = saving <= 0;
      const amount = bar.querySelector('[data-wm-saving-amount]');
      if (amount) amount.textContent = input.dataset.savingText || '';
    }
    const ladder = section.querySelector('[data-wm-bonus]');
    const lines = bundle ? bundle.querySelectorAll('[data-wm-bonus-line]') : [];
    if (!ladder) {
      lines.forEach((line) => (line.hidden = true));
      return;
    }
    const tiles = Array.from(ladder.querySelectorAll('[data-wm-unlock]'));
    const level = Number(input.dataset.wmLevel) || 1;
    tiles.forEach((tile) => {
      const locked = Number(tile.dataset.wmUnlock) > level;
      tile.classList.toggle('is-locked', locked);
      const note = tile.querySelector('[data-wm-unlock-note]');
      if (note) note.textContent = locked ? ' (locked: choose a bigger bundle)' : ' (included)';
    });
    // "+N FREE Bonuses Included" on every card = tiles unlocked at that card's level
    bundle.querySelectorAll('[data-wm-bundle-input]').forEach((option) => {
      const line = option.closest('.wm-bundle__option')?.querySelector('[data-wm-bonus-line]');
      if (!line) return;
      const count = tiles.filter((tile) => Number(tile.dataset.wmUnlock) <= (Number(option.dataset.wmLevel) || 1)).length;
      line.hidden = count === 0;
      line.querySelector('[data-wm-bonus-text]').textContent = `+${count} FREE ${count === 1 ? 'Bonus' : 'Bonuses'} Included`;
    });
  };

  const syncBundle = (input) => {
    const section = input.closest('.shopify-section') || document;
    syncExtras(input, section);
    section.querySelectorAll('product-form-component input[name="id"]').forEach((field) => {
      field.value = input.value;
    });
    // Keep the theme's sticky add-to-cart bar in step with the chosen pack
    document.querySelectorAll('sticky-add-to-cart').forEach((bar) => {
      bar.dataset.currentVariantId = input.value;
      const title = bar.querySelector('.sticky-add-to-cart__variant');
      const price = bar.querySelector('.sticky-add-to-cart__price');
      if (title && input.dataset.title) title.textContent = input.dataset.title;
      if (price && input.dataset.price) price.textContent = input.dataset.price;
    });
  };
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-wm-bundle-input]');
    if (input) syncBundle(input);
  });
  // On load (and back/forward cache restores) the checked card is the source of truth
  const syncChecked = () => document.querySelectorAll('[data-wm-bundle-input]:checked').forEach(syncBundle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncChecked);
  else syncChecked();
  window.addEventListener('pageshow', syncChecked);

  // Scroll-to-cart buttons
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wm-scroll-cart]');
    if (!button) return;
    const target = document.querySelector('.wm-bundle') || document.querySelector('product-form-component');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Photo strip: infinite auto-scroll on a native scroller, so it stays swipeable.
  // Pauses on hover, focus and touch; respects reduced motion.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initMarquee = (viewport) => {
    if (viewport.wmMarquee) return;
    viewport.wmMarquee = true;
    const track = viewport.querySelector('.wm-ugc__track');
    const originals = Array.from(track.children);
    if (!originals.length) return;

    // Clone the set until one set is wider than the viewport, then once more for the loop.
    const appendClones = () => {
      originals.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
        track.appendChild(clone);
      });
    };
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const setWidth = () => originals.reduce((sum, card) => sum + card.offsetWidth + gap, 0);
    let repeats = 1;
    while (setWidth() * repeats < viewport.clientWidth && repeats < 6) {
      appendClones();
      repeats += 1;
    }
    appendClones();
    track.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.play?.().catch(() => {});
    });
    const loopWidth = setWidth() * repeats;

    const speed = Number(viewport.dataset.speed) || 30;
    let pos = 0;
    let paused = false;
    let resumeTimer;
    let last = performance.now();

    const pause = () => {
      paused = true;
      clearTimeout(resumeTimer);
    };
    const resumeLater = (delay = 0) => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        pos = viewport.scrollLeft;
        paused = false;
      }, delay);
    };
    viewport.addEventListener('mouseenter', pause);
    viewport.addEventListener('mouseleave', () => resumeLater());
    viewport.addEventListener('focusin', pause);
    viewport.addEventListener('focusout', () => resumeLater());
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('touchend', () => resumeLater(2500), { passive: true });
    // Keep manual swipes inside the loop in both directions
    viewport.addEventListener(
      'scroll',
      () => {
        if (!paused) return;
        if (viewport.scrollLeft >= loopWidth) viewport.scrollLeft -= loopWidth;
        else if (viewport.scrollLeft <= 0) viewport.scrollLeft += loopWidth;
      },
      { passive: true }
    );

    const step = (now) => {
      const dt = Math.min(now - last, 100) / 1000;
      last = now;
      if (!paused && !reduceMotion.matches && viewport.isConnected) {
        pos += speed * dt;
        if (pos >= loopWidth) pos -= loopWidth;
        viewport.scrollLeft = pos;
      }
      if (viewport.isConnected) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const initMarquees = () => document.querySelectorAll('[data-wm-marquee]').forEach(initMarquee);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMarquees);
  else initMarquees();
  document.addEventListener('shopify:section:load', initMarquees);

  // Shipping row: countdown to cutoff_hour:59:59 in the store's time zone (default 23:59:59 ET), then
  // the ship day = N business days (Mon–Fri) after the order day. Computed from the clock, so reloads never reset it.
  const pad = (n) => String(n).padStart(2, '0');
  const formatters = {};
  const zonedNow = (timeZone) => {
    try {
      formatters[timeZone] ||= new Intl.DateTimeFormat('en-US', { timeZone, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const p = Object.fromEntries(formatters[timeZone].formatToParts(new Date()).map((x) => [x.type, Number(x.value)]));
      return { y: p.year, m: p.month, d: p.day, secs: p.hour * 3600 + p.minute * 60 + p.second };
    } catch {
      const now = new Date();
      return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate(), secs: now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds() };
    }
  };
  // Seconds left until the cutoff (HH:59:59); a negative value means today's cutoff has passed
  const untilCutoff = (hour, now) => (Number.isFinite(hour) ? hour : 23) * 3600 + 3599 - now.secs;
  const shipDayLabel = (el) => {
    const now = zonedNow(el.dataset.wmTimezone || 'America/New_York');
    const offset = Math.max(0, Number(el.dataset.wmShipDay) || 0);
    const DAY = 86400000;
    const today = Date.UTC(now.y, now.m - 1, now.d);
    let day = untilCutoff(parseInt(el.dataset.wmCutoff, 10), now) < 0 ? today + DAY : today;
    const isWeekend = (t) => [0, 6].includes(new Date(t).getUTCDay());
    for (let left = offset; left > 0; ) {
      day += DAY;
      if (!isWeekend(day)) left -= 1;
    }
    if (offset === 0) while (isWeekend(day)) day += DAY;
    if (day === today) return 'Today';
    if (day === today + DAY) return 'Tomorrow';
    return new Date(day).toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });
  };
  const tick = () => {
    document.querySelectorAll('[data-wm-countdown]').forEach((el) => {
      let diff = untilCutoff(parseInt(el.dataset.wmCountdown, 10), zonedNow(el.dataset.wmTimezone || 'America/New_York'));
      if (diff < 0) diff += 86400;
      el.textContent = `${pad(Math.floor(diff / 3600))}:${pad(Math.floor((diff % 3600) / 60))}:${pad(diff % 60)}`;
    });
    document.querySelectorAll('[data-wm-ship-day]').forEach((el) => {
      const label = shipDayLabel(el);
      if (el.textContent !== label) el.textContent = label;
    });
  };
  tick();
  setInterval(tick, 1000);
})();
